import { toast } from "react-toastify";
import GetApiCall from "../../Api/GetApi";
import { delay } from "../../Helper/ToastDelay";
import { SomethingWrong } from "../../Helper/ErrorMessages";
import PostApiCall from "../../Api/Api";
import Notiflix from "notiflix";
export const NOTIFY_REQUEST = "NOTIFY_REQUEST";
export const NOTIFY_SUCCESS = "NOTIFY_SUCCESS";
export const NOTIFY_FAIL = "NOTIFY_FAIL";
export const NOTIFY_ADD_REQUEST = "NOTIFY_ADD_REQUEST";
export const NOTIFY_ADD_SUCCESS = "NOTIFY_ADD_SUCCESS";
export const NOTIFY_ADD_FAIL = "NOTIFY_ADD_FAIL";



export class NotificationAction{
    static Job_GetNotification(id,usertype) {
        return async (dispatch) => {
            Notiflix.Loading.standard();
            dispatch({ type: NOTIFY_REQUEST });
          try {
            const res = await PostApiCall.postRequest({id,usertype},"Job_GetNotification");
            const { data } = await res.json();
          
            dispatch({ type: NOTIFY_SUCCESS, payload: data });
          } catch (error) {
            dispatch({ type: NOTIFY_FAIL, payload: error });
            toast.error(SomethingWrong, {
              autoClose: delay,
            });
          }
          Notiflix.Loading.remove();
        };
      }
      static addNotification(Fdata) {
        return async (dispatch) => {
            dispatch({ type: NOTIFY_ADD_REQUEST });
          try {
            const res = await PostApiCall.postRequest(Fdata,"Job_AddNotification");
            const { data } = await res.json();
          
    
            dispatch({ type: NOTIFY_ADD_SUCCESS, payload: data });
          } catch (error) {
            dispatch({ type: NOTIFY_ADD_FAIL, payload: error });
            toast.error(SomethingWrong, {
              autoClose: delay,
            });
          }
        };
      }
}